import React from 'react';
import { Alert } from 'react-bootstrap';
import styles from './UnsavedChangesNotice.module.scss';

interface UnsavedChangesNoticeProps {
  show: boolean;
  children?: React.ReactNode;
}

export function FormSubmitRow(props: { children: React.ReactNode }) {
  return <div className={styles.row}>{props.children}</div>;
}

export function UnsavedChangesNotice(props: UnsavedChangesNoticeProps) {
  const { show, children } = props;
  if (!show) {
    return null;
  }

  return (
    <Alert variant="warning" className={styles.notice}>
      {children ?? 'You have unsaved changes.'}
    </Alert>
  );
}
